export default "__VITE_ASSET__BiVUZZhs__"